export const DebtorPortalNote = {
  initFormData: {
    note: ""
  },
  isSending: false
};
